import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import UFOSegment from '@atlassian/jira-ufo-segment';
import { PACKAGE_NAME, SOURCE_NAME, TEAM } from './common/constants';
import PrioritiesPage from './ui';

export default function PrioritiesPageWrapper() {
	return (
		<UFOSegment name="admin-pages-priorities-page">
			<JSErrorBoundary
				id="errorBoundary"
				packageName={PACKAGE_NAME}
				teamName={TEAM}
				sendToPrivacyUnsafeSplunk
			>
				<ContextualAnalyticsData sourceName={SOURCE_NAME} sourceType={SCREEN}>
					<PrioritiesPage />
					<FireScreenAnalytics />
				</ContextualAnalyticsData>
			</JSErrorBoundary>
		</UFOSegment>
	);
}
